import React from 'react';

import UiCatalog from './UiCatalog';

export const UI_CATALOG_PATH = '/dev/ui-catalog';

export const getUiCatalogRoutes = (isDev: boolean) =>
    isDev
        ? [
              {
                  key: 'ui-catalog',
                  path: UI_CATALOG_PATH,
                  element: <UiCatalog />,
                  isPrivate: false,
                  shouldHide: false,
                  shouldRedirect: false,
              },
          ]
        : [];
